<template>
  <resource-edit-wrapper
    :title="$t('resources.footers.edit_footer')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['footerForm'].submit()">
    <FooterForm is-edit :footer="item" @isDirtyForm="isDirtyForm" ref="footerForm"></FooterForm>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";
  import FooterForm from "@/components/forms/FooterForm";

  export default {
    components: {
      ResourceEditWrapper,
      FooterForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    created() {
      this.$admin.toast.info(this.$t("generic.edit_warning.warning") + this.$t("generic.edit_warning.footer"));
    },
  };
</script>
